















































































































































































































































import { Component, Vue, Inject, Prop } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";
import DashboardModule, { MODULE_ID } from "../..";
import { MenuItem } from "@abaco/web-common/src/app/Application";
import SSOModule from "@abaco/sso-web-module/src/abaco-module";
import EuropeFlag from "./private/EuropeFlag.vue";

@Component({
    components: { EuropeFlag }
})
export default class HeaderMaltaPmPMainButton extends Vue {
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
    @Inject(MODULE_ID) DashboardModule!: DashboardModule;
    @Inject(SSOModule.MODULE_ID) ssoModule!: SSOModule;

    @Prop() homePage!: MenuItem;

    private agriconnectColorDarkBlue = "#269eb1";
    private agriconnectColorGreen = "#2bb572";
    private agriconnectColorLightBlue = "#72b4c4";
    private agrihubColorBrown = "#925f36";
    private agrihubColorBlue = "#1b71b8";
    private agrihubColorGreen = "#17a199";

    private agriconnectWidthSize: string | null = null;
    private agriconnectHeightSize: string | null = "34px";
    private agrihubWidthSize: string | null = null;
    private agrihubHeightSize: string | null = "34px";

    private europeBanners: { firstLine: string; secondLine: string }[] = [
        { firstLine: "The european agricultural fund for rural development", secondLine: "Europe investing in rural areas" },
        { firstLine: "II-fond agrikolu ewropew għall-iżvilupp rurali", secondLine: "L-Ewropa tinvesti fiż-żoni Rurali" }
    ];

    private get agriconnectColorTop() {
        return this.agriconnectColorDarkBlue;
    }
    private get agriconnectColorBottom() {
        return this.agriconnectColorLightBlue;
    }
    private agriconnectSizeStyle = {
        width: this.agriconnectWidthSize ? this.agriconnectWidthSize : "auto",
        height: this.agriconnectHeightSize ? this.agriconnectHeightSize : "auto"
    };
    private agrihubSizeStyle = {
        width: this.agrihubWidthSize ? this.agrihubWidthSize : "auto",
        height: this.agrihubHeightSize ? this.agrihubHeightSize : "auto"
    };
}
